module.exports = __webpack_public_path__ + "img/message@2x.651579a5.png";